import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import iconCal from "@img/calendar.png";
import iconAuth from "@img/writer.png";
import FloatingMenu from '../components/FloatingMenu';

const BeritaDetail = () => {
    const { id } = useParams();
    const [newsData, setNewsData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://cms.okoce.net/api/admin/news/${id}`);
                if (!response.ok) {
                    throw new Error('Gagal mengambil data berita');
                }
                const data = await response.json();
                setNewsData(data.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!newsData) {
        return <p>Event tidak ditemukan</p>;
    }

    const removeFigcaptionFromDescription = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const figcaptions = doc.querySelectorAll('figcaption');
        figcaptions.forEach(figcaption => figcaption.remove());
        return doc.body.innerHTML;
    };

    const extractImagesFromDescription = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const images = doc.querySelectorAll('img');
        const imageUrls = Array.from(images).map(img => img.src);
        return imageUrls;
    };

    const cleanedDescription = removeFigcaptionFromDescription(newsData.description);
    const imageUrls = extractImagesFromDescription(newsData.description);

    return (
        <>
            <div className="bg-gray-100">
                <div className="max-w-4xl mx-auto mt-24 p-4">
                    <div className="bg-white shadow-md rounded-lg p-10">
                        <div className="w-[90%] mx-auto">
                            <h1 className="font-bold text-3xl">{newsData.title}</h1>
                            <div className="flex mt-5">
                                <div className="flex justify-items-center">
                                    <div className="mt-1">
                                        <img src={iconCal} alt=""></img>
                                    </div>
                                    <div className="ml-2">
                                        <h3>{newsData.date}</h3>
                                    </div>
                                </div>
                                <div className="flex justify-items-center ml-5">
                                    <div className="mt-1">
                                        <img src={iconAuth} alt=""></img>
                                    </div>
                                    <div className="ml-2">
                                        <h3>{newsData.author}</h3>
                                    </div>
                                </div>
                            </div>

                            {imageUrls.length > 0 && (
                                <img
                                    className="object-cover w-full mobile:h-36 lg:h-96"
                                    src={imageUrls[0]} 
                                    alt={`From ${newsData.title}`}
                                />
                            )}

                            <div className="w-full mt-14 mx-auto border-[#1c75ac]">
                                <p className="text-lg text-black text-justify pb-4" dangerouslySetInnerHTML={{ __html: cleanedDescription }} />
                            </div>
                        </div>
                    </div>
                </div >
            </div>
            <FloatingMenu />{" "}
        </>
    );
};

export default BeritaDetail;
